import * as React from 'react'
import { Helmet } from 'react-helmet'
import { Box, Typography } from '@mui/material'
import { ACCESS_DENIED_REASONS } from '../../stores/contextAccess'
import { accessDeniedOverlaySx } from './overlayLayout'

const COMPACT_COPY = {
    [ACCESS_DENIED_REASONS.REQUIRES_LOGIN]: 'This graph is private.',
    [ACCESS_DENIED_REASONS.FORBIDDEN]: 'Access denied.',
    [ACCESS_DENIED_REASONS.NOT_FOUND]: 'Graph not found.',
    [ACCESS_DENIED_REASONS.UNAVAILABLE]: 'Unavailable. Refresh to retry.',
}

export default function AccessDeniedCompact({ reason }) {
    const message =
        COMPACT_COPY[reason] ?? COMPACT_COPY[ACCESS_DENIED_REASONS.FORBIDDEN]

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex" />
            </Helmet>
            <Box
                role="alert"
                className="access-denied-compact"
                sx={{ ...accessDeniedOverlaySx, p: 2 }}
            >
                <Typography variant="body1" align="center" color="text.primary">
                    {message}
                </Typography>
            </Box>
        </>
    )
}
